import React from "react"
import monstaTipster from "../../../assets/images/products/tipster/Mosta_for_EasyTipster.png"
import { Trans, useTranslation } from '../../../plugins/i18next/ea-react-i18next';
import Button from "../../Start/Button";
import ReactWOW from "../../ReactWOW/ReactWOW";

const TipsterPlayNow: React.FC<{}> = () => {
  const { t } = useTranslation("components", { keyPrefix: 'products.tipster.tipsterPlayNow' });

   return (
      <div className={`hero-banner hero-tipster`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className={`hero-banner-content`}>
                <ReactWOW delay='.1s' animation='fadeInLeft'>
                  <h1><Trans t={t}>{t("title")}</Trans></h1>
                </ReactWOW>
                <ReactWOW delay=".1s" animation="fadeInRight">
                  <div className="banner-btn">
                      <Button href="https://app.easytipster.cloud" external={true} text={t("callToAction")} />
                  </div>
                </ReactWOW>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 productbannerimg">
              <div className={`main-unicorn`}>
                <ReactWOW delay='.1s' animation='fadeInRight'>
                  <img src={monstaTipster} alt="features" />
                </ReactWOW>
              </div>
            </div>
          </div>
        </div>
      </div>
   )
}


export default TipsterPlayNow;
